import { render } from "./CollapsedContent.vue?vue&type=template&id=042fd7f8"
import script from "./CollapsedContent.vue?vue&type=script&lang=js"
export * from "./CollapsedContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__